"use strict";
angular.module("planCommandMonitorBeforeSelectTopicRouterModule", ['planCommandMonitorBeforeSelectTopicModule','planCommandMonitorBeforeSelectTopicCompileModule'])
    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state("front.planningresource.commandMonitor.beforeselecttopic", {
                url: '/beforeselecttopic',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/beforeSelectTopic/beforeSelectTopic_tpl.html',
                        controller: 'planCommandMonitorBeforeSelectTopicCtrl'
                    }
                }
            })
            .state("front.planningresource.commandMonitor.compile", {
                url: '/beforeselecttopiccompile?id&title',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/beforeSelectTopic/compile/beforeSelectTopicCompile_tpl.html',
                        controller: 'planCommandMonitorBeforeSelectTopicCompileCtrl',
                    }
                }
            });
    }]);
